import { loginData } from '@/store/modules/login'
import router from '@/router'
import { getToken } from '@/request/common';
import {getUrlParams} from '@/utils/tool'
const initData = async () => {
  return new Promise(async (reslove, reject) => {
    const loginStore = loginData() 
    const id = getUrlParams(window.location.href, 'id')
    if(id != loginStore?.id) {
      loginStore.reset()
    }
    const token = loginStore.token
    if(!token || typeof token != 'string') {
      if(id) {
        // id有值的情况下去获取
        const res: any = await getToken({requestValue:id})
        loginStore.updateToken(res.data)
        loginStore.updateID(id)
      }
    }
    const signatureData = {
      url:location.href.split('#')[0]
    }
    reslove(true)
  })
}
router.beforeEach(async (to, from, next) => {
  // 后面鉴权使用
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  const res = await initData()
  next();
});
 